<ziro-collapsible-section-card
  data-automation="call-flows-section"
  [isSwitchHidden]="true"
  [isCollapsible]="false"
  [title]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.list.title'"
  [subtext]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.list.helptext'"
  [icon]="ZiroIcons.CODE_BRANCH"
>
  <div class="row">
    <div class="col-md-6">
      <label class="col-form-label col-12 pb-0" data-automation="call-flow-standard-label">
        {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.list.standard.title' | translate }}
      </label>

      <div data-automation="standard-call-flows-list">
        @for (flow of standardCallFlows(); track flow.id) {
          <div
            class="call-flow-list__row-summary d-flex align-items-center gap-2 px-3 py-2"
            [class.call-flow-list__row-summary--active]="isExpanded(flow.id)"
            (click)="toggleFlow(flow)"
            [attr.data-automation]="'call-flow-nav-item-' + flow.id"
          >
            <span
              class="call-flow-list__name text-truncate flex-grow-1"
              [ngbTooltip]="tooltipOnTruncate(flow.name)"
              [attr.data-automation]="'call-flow-item-label-' + flow.id"
            >
              {{ flow.name }}
            </span>
            @if (flowsWithErrors().has(flow.id)) {
              <span
                [class]="ZiroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger'"
                data-automation="call-flow-error-icon"
              ></span>
            }
            <ziro-button
              [cssClass]="'ms-1 btn-border'"
              [dataAutomation]="'holiday-call-flow-copy-button'"
              [icon]="ZiroIcons.COPY"
              [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
              [buttonSize]="ButtonSizes.XSMALL"
              (click)="$event.stopPropagation(); onDuplicateHolidayCallFlow(flow)"
            ></ziro-button>
          </div>
        }
      </div>

      <label class="col-form-label col-12 pb-0" data-automation="call-flow-holiday-label">
        {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.list.holidays' | translate }}
      </label>

      <div data-automation="holiday-call-flows-list">
        @if (localHolidayCallFlows().length === 0) {
          <div class="call-flow-list__empty text-muted" data-automation="no-holidays-message">
            {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.list.no_holidays' | translate }}
          </div>
        } @else {
          @for (flow of localHolidayCallFlows(); track flow.id) {
            <div
              class="call-flow-list__row-summary d-flex align-items-center gap-2 px-3 py-2"
              [class.call-flow-list__row-summary--active]="isExpanded(flow.id)"
              (click)="toggleFlow(flow)"
              [attr.data-automation]="'call-flow-nav-item-' + flow.id"
            >
              <span
                class="call-flow-list__name text-truncate flex-grow-1"
                [attr.data-automation]="'call-flow-item-label-' + flow.id"
              >
                {{ flow.name }}
              </span>
              @if (flowsWithErrors().has(flow.id)) {
                <span
                  [class]="ZiroIcons.EXCLAMATION + ' fa animate__animated animate__infinite animate__tada text-danger'"
                  data-automation="call-flow-error-icon"
                ></span>
              }
              <ziro-button
                [cssClass]="'ms-1 text-danger btn-border'"
                [dataAutomation]="'holiday-call-flow-delete-button'"
                [icon]="ZiroIcons.DELETE_SMALL"
                [buttonStyle]="ButtonStyles.OUTLINE_DANGER"
                [buttonSize]="ButtonSizes.XSMALL"
                (click)="$event.stopPropagation(); onDeleteHolidayCallFlow(flow)"
              ></ziro-button>
              <ziro-button
                [cssClass]="'ms-1 btn-border'"
                [dataAutomation]="'holiday-call-flow-copy-button'"
                [icon]="ZiroIcons.COPY"
                [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
                [buttonSize]="ButtonSizes.XSMALL"
                (click)="$event.stopPropagation(); onDuplicateHolidayCallFlow(flow)"
              ></ziro-button>
            </div>
          }
        }
      </div>

      <div class="d-flex justify-content-end mt-4 px-3">
        <ziro-button
          [label]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.add.label'"
          [dataAutomation]="'add-call-flow-button'"
          [icon]="ZiroIcons.ADD"
          [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
          [buttonSize]="ButtonSizes.MEDIUM"
          (clicked)="onAddHolidayCallFlow()"
        ></ziro-button>
      </div>
    </div>

    <div class="col-md-6">
      @if (selectedCallFlow(); as flow) {
        @if (flow.isHoliday) {
          @for (holidayCallFlow of [flow]; track holidayCallFlow.id) {
            <ziro-holiday-call-flow-form
              class="d-block"
              [holidayCallFlow]="holidayCallFlow"
              [allHolidays]="allHolidays()"
              (callFlowNameChange)="onHolidayCallFlowNameChange(holidayCallFlow.id, $event)"
              (validityChange)="onHolidayValidityChange($event)"
            ></ziro-holiday-call-flow-form>
          }
        } @else {
          <ziro-weekly-schedule
            [schedule]="currentSchedule()"
            [callFlow]="flow"
            (scheduleChange)="onScheduleChange($event)"
            (selectBusinessHoursFlow)="onNavigateToBusinessHours()"
          ></ziro-weekly-schedule>
        }
      }
    </div>
  </div>

  @if (selectedCallFlow(); as selectedFlow) {
    @for (flow of [selectedFlow]; track flow.id) {
      <ziro-call-flow-greetings
        class="d-block mt-3"
        [tenantId]="tenantId()"
        [prompt]="currentGreeting()"
        [pendingGreetingOption]="currentPendingGreetingOption()"
        [pendingGreetingFile]="currentGreetingFile()"
        [dataAutomation]="'call-flow-greetings'"
        (greetingUpdate)="onGreetingUpdate(flow.id, $event)"
        (validityChange)="onGreetingsValidityChange($event)"
      ></ziro-call-flow-greetings>
    }
  }

  @for (flow of allCallFlows(); track flow.id) {
    <div [hidden]="selectedCallFlow()?.id !== flow.id">
      <ziro-auto-attendants-call-flow-edit
        [callFlow]="flow"
        [tenantId]="tenantId()"
        [allHolidays]="allHolidays()"
        (callFlowNameChange)="onHolidayCallFlowNameChange(flow.id, $event)"
        (greetingUpdate)="onGreetingUpdate(flow.id, $event)"
      ></ziro-auto-attendants-call-flow-edit>
    </div>
  }
</ziro-collapsible-section-card>
